import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_VEHICLES_LIST,
  CREATE_VEHICLES,
  EDIT_VEHICLES_BY_ID,
  LOAD_VEHICLES_BY_ID,
  DELETE_VEHICLES, LOAD_TELEMETRY_LIST_ALL,
} from './actions';
import { TELEMETRY_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  telemetryListMeta: {},
  loadingTelemetryList: false,
  telemetryList: [],
  loadingCurrentTelemetry: false,
  currentTelemetry: {},
  loadingCreateTelemetry: false,
  loadingEditTelemetryById: false,
  loadingDeleteTelemetry: false,
  telemetryListAll: [],
  loadingTelemetryListAll: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(TELEMETRY_MODULE + LOAD_VEHICLES_LIST, 'telemetryList', 'loadingTelemetryList'),
  ...createLoadListReducerWithBegin(TELEMETRY_MODULE + LOAD_TELEMETRY_LIST_ALL, 'telemetryListAll', 'loadingTelemetryListAll'),
  ...updateLoadParameterReducer(TELEMETRY_MODULE + LOAD_VEHICLES_BY_ID, 'currentTelemetry', 'loadingCurrentTelemetry', {}),
  ...createOperationStateReducer(TELEMETRY_MODULE + CREATE_VEHICLES, 'loadingCreateTelemetry'),
  ...createOperationStateReducer(TELEMETRY_MODULE + EDIT_VEHICLES_BY_ID, 'loadingEditTelemetryById'),
  ...createOperationStateReducer(TELEMETRY_MODULE + DELETE_VEHICLES, 'loadingDeleteTelemetry'),
}, initialState);

export default reducer;

export const getTelemetryData = createSelector(
  [state => state[TELEMETRY_MODULE]],
  state => {
    const {
      telemetryListMeta,
      loadingTelemetryList,
      telemetryList,
      loadingCurrentTelemetry,
      currentTelemetry,
      loadingCreateTelemetry,
      loadingEditTelemetryById,
      loadingDeleteTelemetry,
      telemetryListAll,
      loadingTelemetryListAll,
    } = state;
    return {
      telemetryListMeta,
      loadingTelemetryList,
      telemetryList,
      loadingCurrentTelemetry,
      currentTelemetry,
      loadingCreateTelemetry,
      loadingEditTelemetryById,
      loadingDeleteTelemetry,
      telemetryListAll,
      loadingTelemetryListAll,
    };
  },
);
